"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Attention = function Attention(_ref) {
  var props = _extends({}, _ref);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "16",
    height: "14",
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("path", {
      d: "M7.33332 8.66675V6.00008H8.66666V8.66675H7.33332Z",
      fill: "#B00020"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M8.66666 10.6667C8.66666 11.0349 8.36818 11.3334 7.99999 11.3334C7.6318 11.3334 7.33332 11.0349 7.33332 10.6667C7.33332 10.2986 7.6318 10.0001 7.99999 10.0001C8.36818 10.0001 8.66666 10.2986 8.66666 10.6667Z",
      fill: "#B00020"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.58276 1.00965C8.46518 0.798009 8.2421 0.666748 7.99999 0.666748C7.75788 0.666748 7.5348 0.798009 7.41722 1.00965L0.750552 13.0097C0.635836 13.2161 0.638952 13.4679 0.758743 13.6715C0.878533 13.8751 1.09711 14.0001 1.33332 14.0001H14.6667C14.9029 14.0001 15.1214 13.8751 15.2412 13.6715C15.361 13.4679 15.3641 13.2161 15.2494 13.0097L8.58276 1.00965ZM2.46633 12.6667L7.99999 2.70616L13.5336 12.6667H2.46633Z",
      fill: "#B00020"
    })]
  }));
};

var _default = Attention;
exports["default"] = _default;